<template>
  <!-- 我的课程 -->
  <div class="index-container">
    <bannerImg :bannerText="bannerText" :isShowTab="true"></bannerImg>
    <personalSidebar>
      <div class="right-content">
        <div class="r-title">我的课程</div>
        <div class="type-tab-box">
          <div
            class="type-list"
            :class="typeActive === index?'type-active':''"
            v-for="(item,index) in typeList"
            :key=" 'type' + index"
            @click="typeSelect(item,index)"
          >{{item.title}}</div>
        </div>
        <div class="course-box">
          <div class="course-list" v-for="(item,index) in courseList" :key=" 'course' + index">
            <div class="first-box">
              订单编号：{{item.order_sn}}
              <span>下单时间：{{item.create_time}}</span>
              <span class="type-text no-start" v-if="item.order_state == -1">已取消</span>
              <span
                v-else
                class="type-text"
                :class="item.order_state === 1?'no-start':(item.order_state === 3?'have-text':(item.order_state === 2?'ing-text':''))"
              >{{item.order_state === 0?'待付款': (item.order_state === 1?'未开始':(item.order_state === 2?'上课中':'已完成'))}}</span>
            </div>
            <div class="second-box">
              <div
                class="c-img"
                @click="goDetail(item)"
                :style="{ backgroundImage: 'url( ' + imgUrl + item['cover']+ ')' }"
              ></div>
              <div class="right-box">
                <div
                  class="c-title"
                  :class="item.order_state === 3 || item.order_state === 1?'title-ing':''"
                >{{item.course_title}}</div>
                <div
                  class="c-time"
                  :class="item.order_state === 1?'time-ing':''"
                ></div>
                <div class="btn-box">
                  <div
                    class="btn pay-btn"
                    @click.stop="pay(item)"
                    v-if="item.order_state === 0"
                  >立即付款</div>
                  <div
                    class="btn yellow-btn"
                    @click.stop="goDetail(item)"
                    v-if="item.order_state !== 0 && item.order_state !== -1"
                  >课程表</div>
                  <template v-if="item.order_state === 3">
                    <div class="btn yellow-btn">查看证书</div>
                    <div class="btn yellow-btn">填写满意度调查表</div>
                  </template>
                  <div
                    class="btn no-btn"
                    @click.stop="cancelOrder(item)"
                    v-if="item.order_state === 0"
                  >取消订单</div>
                  <div
                    class="btn no-btn"
                    @click.stop="evaluateOrder(item)"
                    v-if="item.order_state !== 0 && item.order_state !== -1"
                  >立即评价</div>
                </div>
                <div class="contact-text" @click="contactPeople()">
                  <i class="iconfont-icon icon-kefu"></i>联系客服
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="page_index"
          :page-size="page_size"
          :total="listTotal"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </personalSidebar>
    <!-- 选择付款方式 -->
    <el-dialog class="form-box" :visible.sync="wayVisible" width="570PX">
      <div class="form-title">选择付款方式</div>
      <div class="way-box">
        <div
          class="way-list"
          @click="waySelect(item,index)"
          v-for="(item, index) in wayList"
          :key="'way' + index"
          :class="index === wayIndex?'way-active':''"
        >
          <div class="active-img" :style="{ backgroundImage: 'url( ' + activeImg + ')' }"></div>
          <i class="iconfont-icon" :class="item.icon"></i>
          {{ item.name }}
        </div>
      </div>
      <div class="submit-button" @click="wayNext">下一步</div>
    </el-dialog>
    <!-- 付款信息 -->
    <el-dialog
      :close-on-click-modal="false"
      class="form-box"
      :visible.sync="infoVisible"
      width="570PX"
    >
      <div class="form-title">付款信息</div>
      <div class="text-box first-box">
        <div class="t-title">课程名称：{{wayInfo.order_name}}</div>
        <div class="t-text">
          应付金额：
          <span>¥{{wayInfo.order_amount}}</span>
        </div>
      </div>
      <div
        class="code-img"
        :style="{ backgroundImage: 'url( ' + imgUrl + wayInfo['pay_url']+ ')' }"
      ></div>
      <div class="text-box">
        <div class="t-text">流水号：{{wayInfo.order_sn}}</div>
        <div class="t-text">付款日期：{{wayInfo.create_time}}</div>
      </div>
      <div class="submit-button have-btn" @click="havePay">已支付</div>
    </el-dialog>
    <!-- 付款信息2 -->
    <el-dialog
      :close-on-click-modal="false"
      class="form-box"
      :visible.sync="infoTwoVisible"
      width="40%"
    >
      <div class="form-title">付款信息</div>
      <div class="text-box">
        <div class="t-title">课程名称：{{wayInfo.order_name}}</div>
        <div class="t-text">
          应付金额：
          <span>¥{{wayInfo.order_amount}}</span>
        </div>
      </div>
      <div class="text-box">
        <div class="t-text">流水号：{{wayInfo.order_sn}}</div>
        <div class="t-text">付款日期：{{wayInfo.create_time}}</div>
      </div>
      <div class="way-title">收款信息</div>
      <div class="money-box">
        <div class="money-info">
          公司名称：
          <span>{{wayInfo.company_name}}</span>
        </div>
        <div class="money-info">
          开户银行：
          <span>{{wayInfo.company_bank}}</span>
        </div>
        <div class="money-info">
          收款账号：
          <span>{{wayInfo.company_no}}</span>
        </div>
      </div>
      <template>
        <div class="way-title">付款凭证</div>
        <div class="tip-text">*请打款到指定收款账号并上传支付凭证截图</div>
        <el-upload
          :action="uploadUrl"
          list-type="picture-card"
          :on-remove="handleRemove"
          :on-success="successUpload"
          :file-list="fileList"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </template>
      <div class="submit-button have-btn" @click="havePay">已支付</div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible" width="580PX" :close-on-click-modal="false">
      <div class="dialog-title">联系客服</div>
      <div class="result-box">
        <div>0755-9823654</div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="cancelVisible" width="580PX" :close-on-click-modal="false">
      <div class="dialog-title">订单取消原因</div>
      <div class="select-list">
        <el-radio v-model="reason" label="排错/多拍了">排错/多拍了</el-radio>
      </div>
      <div class="select-list">
        <el-radio v-model="reason" label="地址填错了">地址填错了</el-radio>
      </div>
      <div class="select-list">
        <el-radio v-model="reason" label="不想要了">不想要了</el-radio>
      </div>
      <div class="select-list">
        <el-radio v-model="reason" label="其他">其他</el-radio>
      </div>
      <div class="dialog-btn-box">
        <!-- <div class="btn" @click="goPay1">去支付</div> -->
        <div class="btn cancel" @click="confirmCancelOrder">取消订单</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import bannerImg from '../components/bannerImg.vue';
import personalSidebar from '../components/personalSidebar.vue';
import api from '../api/api';
import { upload_url } from '../api/index';
import { imgUrl } from '../api/index';
import selectImg from '@/assets/img/gouxuan_bg.png';

export default {
  name: 'myCourse',
  components: {
    bannerImg,
    personalSidebar
  },
  data() {
    return {
      activeImg: selectImg,
      imgUrl: imgUrl,
      bannerText: '我的课程',
      typeList: [
        {
          title: '全部订单',
          id: ''
        },
        {
          title: '待付款',
          id: 0
        },
        {
          title: '未开始',
          id: 1
        },
        {
          title: '上课中',
          id: 2
        },
        {
          title: '已完成',
          id: 3
        },
        {
          title: '已取消',
          id: -1
        }
      ],
      typeActive: 0,
      courseList: [],
      listTotal: 0,
      page_size: 5,
      page_index: 1,
      order_state: '',
      wayList: [
        // 付款方式
        {
          icon: 'icon-weixinfukuan',
          name: '微信支付',
          id: 2
        },
        {
          icon: 'icon-zhifubao',
          name: '支付宝支付',
          id: 1
        },
        {
          icon: 'icon-duigongzhuanzhang',
          name: '对公转账',
          id: 3
        },
        {
          icon: 'icon-xianjinzhifu',
          name: '现金支付',
          id: 4
        }
      ],
      pay_type: '',
      wayIndex: '',
      wayVisible: false,
      wayInfo: {},
      infoVisible: false,
      infoTwoVisible: false,
      uploadUrl: upload_url, // 上传地址
      fileList: [],
      detailInfo: {},
      page_index: 1,
      detailId: '',
      problemList: [],
      pay_img: '',
      order_sn: '',
      dialogVisible: false,
      cancelVisible: false,
      reason: ''
    };
  },
  created() {
    this.getMyCourseList();
  },
  mounted() {
    scrollTo(0, 0);
  },
  methods: {
    evaluateOrder(item) {
      console.log(item);
      this.$router.push({
        path: '/evaluateCourse',
        query: { course_uuid: item.course_uuid, order_sn: item.order_sn }
      });
    },
    //   去支付
    goPay1() {
      this.commodityPay();
    },
    // 取消订单
    cancelOrder(item) {
      this.order_sn = item.order_sn;
      this.pay_type = item.pay_type;
      this.detailId = item.course_uuid;
      this.order_sn = item.order_sn;
      this.cancelVisible = true;
    },
    // 确认取消
    confirmCancelOrder() {
      if (!this.reason) {
        this.$message.warning('请选择取消原因！');
        return;
      }
      const params = {
        cancel_mark: this.reason,
        order_sn: this.order_sn
      };
      api.cancelCourseOrder(params).then(res => {
        if (res.result) {
          this.$message.warning('取消成功！');
          this.reason = '';
          this.getMyCourseList();
          this.cancelVisible = false;
        } else {
          this.$message.warning('取消失败！');
        }
      });
    },
    // 联系客服
    contactPeople() {
      this.dialogVisible = true;
    },
    // 支付
    pay(item) {
      this.order_sn = item.order_sn;
      //   this.pay_type = item.pay_type;
      this.detailId = item.course_uuid;
      this.wayVisible = true;
      //   this.commodityPay();
    },
    // 支付方式选择
    waySelect(item, index) {
      this.pay_type = item.id;
      this.wayIndex = index;
    },
    // 课程等级
    rankChange(val) {
      this.rank = val;
    },
    // 获取课程表
    getTimetable(item) {
      this.$router.push({
        path: '/myCourseDetail',
        query: { id: item.order_id, uuid: item.course_uuid }
      });
    },
    //   获取课程列表
    getMyCourseList() {
      const params = {
        page_index: this.page_index,
        page_size: this.page_size,
        order_state: this.order_state
      };
      api.getMyCourseList(params).then(res => {
        if (res && res.result) {
          this.courseList = res.result.data;
          this.listTotal = res.result.total;
        }
      });
    },
    typeSelect(item, index) {
      this.typeActive = index;
      this.order_state = item.id;
      this.page_index = 1;
      this.getMyCourseList();
    },
    goDetail(item) {
      this.$router.push({
        path: '/myCourseDetail',
        query: { id: item.order_id, uuid: item.course_uuid ,pdf_url: item.pdf_url}
      });
    },
    // 页码改变
    handleCurrentChange(val) {
      this.page_index = val;
      this.getMyCourseList();
    },
    // 付款方式后下一步
    wayNext() {
      if (!this.pay_type) {
        this.$message.warning('请选择付款方式！');
      } else {
        // this.commodityPay();
        api
          .uploadPlayImg({
            order_sn: this.order_sn,
            pay_type: this.pay_type
          })
          .then(res => {
            if (res.result) {
              this.commodityPay();
            }
          });
      }
    },
    commodityPay() {
      api.commodityPay({ order_sn: this.order_sn }).then(res => {
        if (res.result) {
          this.wayInfo = res.result;
          this.wayVisible = false;
          if (this.pay_type === 3) {
            this.infoTwoVisible = true;
            return;
          }
          this.infoVisible = true;
        } else {
          this.$message.warning('订单信息有误！');
        }
      });
    },
    // 已支付
    havePay() {
      if (this.infoVisible === true) {
        this.infoVisible = false;
        return;
      }
      if (this.wayInfo.pay_state === 1) {
        this.infoTwoVisible = false;
        return;
      }
      if (!this.pay_img) {
        this.$message.warning('请上传支付凭证！');
        return;
      }
      api
        .uploadPlayImg({
          order_sn: this.wayInfo.order_sn,
          pay_img: this.pay_img
        })
        .then(res => {
          if (res.result) {
            this.$message.success('上传成功！');
            this.infoTwoVisible = false;
          }
        });
    },
    // 凭证移除
    handleRemove(file) {
      this.pay_img = '';
    },
    // 上传成功
    successUpload(res, file, fileList) {
      if (res.result) {
        this.pay_img = res.result;
        this.$message.success('上传成功！');
      } else {
        this.$message.warning('上传失败！');
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.index-container {
  padding-bottom: 2PX;
  margin-top: 122PX;
  background-color: #f8f7f6;
}
.right-content {
  width: 72%;
  padding: 32PX 48PX;
  background-color: #ffffff;
  box-shadow: 0PX 3PX 16PX 0PX rgba(228, 228, 228, 0.35);
  border-radius: 10PX;
}
.r-title {
  padding-bottom: 38PX;
  font-size: 20PX;
}
.type-tab-box {
  display: flex;
  border-bottom: 1PX solid #ececec;
  .type-list {
    padding-bottom: 12PX;
    margin-right: 50PX;
    font-size: 18PX;
    border-bottom: 2PX solid transparent;
    cursor: pointer;
    &:hover {
      color: #f1a373;
      border-bottom: 3PX solid #f1a373;
    }
  }
  .type-active {
    color: #f1a373;
    border-bottom: 3PX solid #f1a373;
  }
}
.course-box {
  padding: 46PX 0;
}
.course-list {
  padding: 14PX 25PX 26PX;
  margin-bottom: 24PX;
  background-color: #f8f8f8;
  border-radius: 6PX;
  cursor: pointer;
  .first-box {
    padding-bottom: 14PX;
    margin-bottom: 22PX;
    color: #777777;
    border-bottom: 1PX solid #e5e5e5;
    span {
      padding-left: 30PX;
    }
  }
  .type-text {
    float: right;
    color: #eca021;
  }
  .no-start {
    color: #8c8c8c;
  }
  .have-text {
    color: #3a3a3a;
  }
  .ing-text {
    color: #009b29;
  }
  .second-box {
    display: flex;
  }
  .right-box {
    position: relative;
    flex: 1;
  }
  .c-img {
    width: 168PX;
    height: 108PX;
    margin-right: 16PX;
    background-color: #eeeeee;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  .c-title {
    padding-bottom: 12PX;
    font-size: 16PX;
    font-weight: 500;
  }
  .title-ing {
    color: #999999;
  }
  .c-time {
    padding-bottom: 18PX;
    font-size: 12PX;
    color: #666666;
  }
  .time-ing {
    color: #f1a373;
  }
  .btn-box {
    display: flex;
    .btn {
      padding: 0 14PX;
      margin-right: 16PX;
      font-size: 14PX;
      color: #ffffff;
      text-align: center;
      line-height: 34PX;
      border-radius: 45PX;
      cursor: pointer;
    }
    .pay-btn {
      background-color: #f1a373;
    }
    .yellow-btn {
      color: #f1a373;
      line-height: 32PX;
      border: 1PX solid #f1a373;
    }
    .no-btn {
      color: #cecece;
      line-height: 32PX;
      border: 1PX solid #cecece;
    }
  }
  .contact-text {
    position: absolute;
    right: 0;
    bottom: 12PX;
    color: #666666;
  }
}
/deep/ {
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #fb6d0a;
  }
  .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #ffffff;
    background-color: #fb6d0a;
  }
  .el-pagination {
    text-align: center;
    button {
      width: 42PX;
      height: 42PX;
    }
  }
  .el-pager li {
    width: 42PX;
    height: 42PX;
    line-height: 42PX;
  }
  .el-dialog__body {
    padding: 20PX 40PX;
  }
}

.form-box {
  .form-title {
    padding-bottom: 38PX;
    font-size: 22PX;
    text-align: center;
  }
  .form-question {
    padding-bottom: 16PX;
    font-size: 16PX;
  }
  .rideo-box {
    margin-bottom: 30PX;
  }
  .submit-button {
    width: 218PX;
    height: 52PX;
    margin: 52PX auto 0;
    font-size: 18PX;
    color: #ffffff;
    text-align: center;
    line-height: 52PX;
    background-color: #f1a373;
    border-radius: 45PX;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
  .rank-box {
    text-align: center;
  }
  .way-box {
    display: flex;
    flex-wrap: wrap;
    width: 76%;
    margin: 0 auto;
  }
  .way-list {
    position: relative;
    display: flex;
    align-items: center;
    width: 162PX;
    height: 50PX;
    margin-bottom: 14PX;
    font-size: 16PX;
    line-height: 50PX;
    text-align: center;
    border-radius: 5PX;
    border: 1PX solid #cbcbcb;
    cursor: pointer;
    &:nth-child(2n) {
      margin-left: 45PX;
    }
    &:hover {
      border-color: #f1a475;
      .active-img {
        display: block;
      }
    }
    .iconfont-icon {
      padding: 0 14PX 0 24PX;
      font-size: 28PX;
      line-height: 50PX;
    }
  }
  .way-active {
    border-color: #f1a475;
    .active-img {
      display: block;
    }
  }
  .active-img {
    position: absolute;
    display: none;
    top: 0;
    right: -1PX;
    width: 28PX;
    height: 28PX;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  .icon-weixinfukuan {
    color: #6bcc03;
  }
  .icon-zhifubao {
    color: #189fe4;
  }
  .icon-duigongzhuanzhang {
    color: #faad14;
  }
  .icon-xianjinzhifu {
    color: #f8b551;
  }
  .text-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .t-text:last-child {
      padding-left: 20PX;
    }
  }
  .first-box {
    margin-bottom: 20PX;
  }
  .t-title {
    width: 50%;
    font-size: 16PX;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .t-text {
    font-size: 14PX;
    color: #666666;
    line-height: 40PX;
    span {
      font-size: 30PX;
      color: #c00c0c;
    }
  }
  .code-img {
    width: 358PX;
    height: 322PX;
    margin: 0 auto 32PX;
    background-color: #d8d8d8;
    border: 1PX solid #979797;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  .have-btn {
    margin-top: 20PX;
  }
  .way-title {
    padding: 40PX 0 12PX;
    margin-bottom: 22PX;
    font-size: 16PX;
    color: #f1a475;
    border-bottom: 1PX solid #e7e7e7;
  }
  .money-box {
    padding: 14PX 8PX;
    background-color: #f6f6f6;
  }
  .money-info {
    padding-bottom: 14PX;
    color: #666666;
    span {
      color: #000000;
    }
  }
  .tip-text {
    padding-bottom: 22PX;
    color: #f90000;
  }
}

.dialog-title {
  padding-bottom: 40PX;
  font-size: 22PX;
  font-weight: 500;
  color: #333333;
  text-align: center;
}
.result-box {
  margin-bottom: 30PX;
  text-align: center;
  > div {
    font-size: 22PX;
    font-weight: 600;
  }
  .iconfont {
    padding-bottom: 40PX;
    font-size: 96PX;
    color: #52c41a;
  }
}
.select-box {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 30PX;
  .select-list {
    width: 40%;
    margin-bottom: 20PX;
  }
}
.select-list {
  margin-bottom: 14PX;
}
.dialog-btn-box {
  display: flex;
  justify-content: space-between;
  padding: 30PX 20PX;
  .btn {
    width: 44%;
    font-size: 18PX;
    color: #ffffff;
    line-height: 42PX;
    text-align: center;
    border-radius: 6PX;
    border: 1PX solid #f1a475;
    background-color: #f1a475;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
  .cancel {
    color: #666666;
    border-color: #979797;
    background-color: #ffffff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/myCourse.vue